interface SnsShareBannerProps {
  onClick?: () => void
  className?: string
}

/**
 * SNS拡散バナーコンポーネント
 * カード風のデザインで、SNS拡散を促すバナーを表示
 */
export default function SnsShareBanner({ onClick, className = '' }: SnsShareBannerProps) {
  const handleClick = () => {
    console.log('SNS拡散バナーがクリックされました')
    onClick?.()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`w-full border border-gray-500 bg-gray-100 rounded-lg px-8 py-6 text-center transition-all hover:bg-gray-200 hover:border-gray-600 active:scale-[0.98] ${className}`}
    >
      <span className="text-gray-800 font-bold text-base">SNS用拡散バナーを設置する</span>
    </button>
  )
}
